import {
  getSalesRegion,
} from "@/request/api";

export default{
    tableEmptyField:function(row, column) {
        if(row[column.property]){
            return String(row[column.property]).trim().length > 0 ? row[column.property] : '-';
        } else {
            return '-';
        }
    },
    tableFormatDateTime:function(row, column) {
        if(row[column.property]){
            let date = new Date(row[column.property]);
            let Y = date.getFullYear() + '/';
            let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '/' : date.getMonth() + 1 + '/';
            let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
            let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
            let m = date.getMinutes()  < 10 ? '0' + date.getMinutes()  : date.getMinutes();
            // let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
            return Y + M + D + h + m ;
        }else{
            return '';
        }
    },
    tableFormatDate:function(row, column) {
        if(row[column.property]){
            let date = new Date(row[column.property]);
            let Y = date.getFullYear() + '/';
            let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '/' : date.getMonth() + 1 + '/';
            let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
            return Y + M + D;
        }else{
            return '';
        }
    },
    paramFormatDate:function(value,type) {
        if(value){
            let date = new Date(value);
            let Y = date.getFullYear() + '/';
            let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '/' : date.getMonth() + 1 + '/';
            let D = date.getDate() < 10 ? '0' + date.getDate() + (type==true?'':' ') : date.getDate() + (type==true?'':' ');
            let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
            let m = date.getMinutes()  < 10 ? '0' + date.getMinutes()  : date.getMinutes();
            // let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
            if(type === true){
                return Y + M + D;
            }else{
                return Y + M + D + h + m;
            }
        }else{
            return '';
        }
    },
    paramFormatDateWithSecond:function(value,type) {
        if(value){
            let date = new Date(value);
            let Y = date.getFullYear() + '/';
            let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '/' : date.getMonth() + 1 + '/';
            let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
            let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
            let m = date.getMinutes()  < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
            let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
            if(type === true){
                s = '00';
            }
            return Y + M + D + h + m + s;
        }else{
            return '';
        }
    },
    handleRes:function(that,res,callback) {
        if(typeof callback === 'function'){
            if(res && res.status == 200 && res.data.status != '02'){
                if(res.status == 200){
                    if(res.data.status == '00'){
                        callback();
                    }else{
                        that.$message.error(res.data.msg);
                    }
                }else{
                    that.$message.error(res.statusText);
                }
            }
        }
    },
    routeFormat:function(value) {
        let res = '';
        let valueArr = value.split(' ');
        if(valueArr.length > 0){
            for (let i = 0; i < valueArr.length; i++) {
                if(valueArr[i]){
                    valueArr[i] = valueArr[i].toLowerCase();
                    res += valueArr[i].toLowerCase().replace(valueArr[i][0],valueArr[i][0].toUpperCase());
                }

            }
        }
        return res.replace(value[0],value[0].toLowerCase());
    },
    fluidImage:function(fileList,target){
        for (let i = 0; i < fileList.length; i++) {
            let compareImg = 'width';
            let img = new Image();
            img.src = fileList[i].url;
            img.onload = function(){
                if(img.width >= img.height){
                    compareImg = 'width';
                }else{
                    compareImg = 'height';
                }
                let dom = target[i];
                if(compareImg == 'width'){
                    dom.style.width = '100%';
                    dom.style.height = 'auto';
                    let mTop = (146 - img.height * 146 / img.width) / 2;
                    dom.style.marginTop = mTop + 'px';
                }else{
                    dom.style.width = 'auto';
                    dom.style.height = '100%';
                }
            }
        }
    },getPageParams(parms,pageNum,pageSize){
        return {
            "isPaging": true,
            "jsonOrderBy": {},
            "jsonSearchFilter":parms,
            "pageNum": pageNum,
            "pageSize": pageSize
        }
    },substring(str){
        if(!str)return str;
        if(str.length<1)return str;
        return str.substring(0,str.length-1);
    },isPDF(str){
        if(!str)return false;
        var arr = str.split('.');
        return 'pdf' == arr[arr.length-1];
    },
    hkidFormatter(hkId) {
        if(hkId){
            let newValue;
            newValue = hkId.replace(/[^0-9a-zA-z]/g, "");
            newValue = newValue.slice(0,newValue.length-1)+ "("+newValue.slice(newValue.length-1,newValue.length)+")".toUpperCase();
            return newValue;
        }else{
            return '';
        }

    },
    salesOfficeMap(v){
        if(v=='HK')return 'Hong Kong';
        if(v=='SG')return 'Singapore';
        return v;
    },
    initRegionsMap() {
      if (Object.keys(this.regionListMapping) > 1) {
        // init already
        return ;
      }
      getSalesRegion('').then(res=>{
        const regions = res.data.payload;
        if (!regions) return ;
        regions.forEach(r => {
          this.regionListMapping[r.code] = r.name;
        });
      })
    },
    regionListMapping: {
      // sample data, will fetch from db
      // 'CN': 'China',
      // 'DB': 'UAE',
      // 'HK': 'Hong Kong',
      // 'TW': 'Taiwan',
      // 'JP': 'Japan',
      // 'MY': 'Malaysia',
      // 'SG': 'Singapore',
    },
    regionMap(v){
      return this.regionListMapping[v] || v;
    },
    languageMap(v){
        if(v==('EN'||'en'))return 'English';
        if(v==('ZH_HK'||'zh_hk'))return 'Traditional Chinese';
        if(v==('ZH_CN'||'zh_cn'))return 'Simplified Chinese';
        if(v==('JA'||'ja'))return 'Japanese';
        return v
    },
    userTypeMap(v){
        if(v=='B')return 'Business Partner';
        if(v=='S')return 'Internal Sales';
        if(v=='C')return 'Business Partner Admin';
        if(v=='F')return 'Staff';
        if(v=='CL')return 'Client';
        return v
    },
    sfUserTypeMap(v){
      if(v=='CL' || v=='')return 'Client';
      if(v=='BIZ')return 'Business Partner (Group Admin)';
      if(v=='ADVISOR')return 'Financial Advisor (Individual)';
      if(v=='INTERNAL')return 'Internal';
      return v
    },
    sfUserIdTypeMap(v){
      if(v=='CLIENT_ID' || v=='CL' || v=='')return 'Client';
      if(v=='VENDOR_ID' || v=='BIZ' || v=='ADVISOR' || v=='EMPLOYEE_ID' || v=='INTERNAL') return 'Partner';
      return ''
    },
    userStatusMap(v){
        if(v=='OPENED')return 'Inactive';
        if(v=='ACTIVATED')return 'Active';
        if(v=='SUSPENDED')return 'Suspended';
        if(v=='DELETED')return 'Deleted';
        return v
    },
    locationMap(v){
        if(v=='US')return 'US';
        if(v=='CANADA')return 'Canada';
        return v
    },
    projectStatusMap(v){
        if(v=='AVAILABLE')return 'Available';
        if(v=='WAITLIST')return 'Waitlist';
        if(v=='SOLDOUT')return 'Soldout';
        return v
    },
    cmsUserLevelMap(v){
      if(v=='SUPER_ADMIN') return 'Level 1';
      if(v=='CS_TEAM') return 'Level 2';
      if(v=='SALES_TEAM') return 'Level 3';
      return v
    },
    pushTypeMap(v){
        if(v=='INVESTMENT')return 'Investment Updates';
        if(v=='CORPORATE')return 'Corporate Updates';
        if(v=='MARKET')return 'Market Updates';
        if(v=='SYSTEM')return 'System Updates';
        return v
    },
    pushStatusMap(v){
        if(v=='DELIVERED')return 'Delivered ';
        if(v=='PENDING')return 'Pending';
        if(v=='PUSHING')return 'Pushing';
        if(v=='REVOKED_PENDING')return 'Revoked (Pending)';
        if(v=='REVOKED_DELIVERED')return 'Revoked (Delivered)';
        if(v=='FAILED')return 'Failed';
        return v
    },
    inboxStatusMap(v){
        if(v=='RECEIVED')return 'Received ';
        if(v=='PENDING')return 'Pending';
        if(v=='IGNORED')return 'Ignored';
        if(v=='FAILED')return 'Failed';
        if(v=='DELETED')return 'Deleted';
        return v
    },
    randomPassword(length) {
        length = Number(length)
        // Limit length
        if (length < 8) {
            length = 8
        } else if (length > 20) {
            length = 20
        }
        let passwordArray = ['ABCDEFGHIJKLMNOPQRSTUVWXYZ', 'abcdefghijklmnopqrstuvwxyz', '1234567890', '!@#$%&*()'];
        var password = [];
        let n = 0;
        for (let i = 0; i < length; i++) {
            // If password length less than 9, all value random
            if ( password.length < (length - 4) ) {
            // Get random passwordArray index
            let arrayRandom = Math.floor(Math.random() * 4);
            // Get password array value
            let passwordItem = passwordArray[arrayRandom];
            // Get password array value random index
            // Get random real value
            let item = passwordItem[Math.floor(Math.random() * passwordItem.length)];
            password.push(item);
            } else {
            // If password large then 9, lastest 4 password will push in according to the random password index
            // Get the array values sequentially
            let newItem = passwordArray[n];
            let lastItem = newItem[Math.floor(Math.random() * newItem.length)];
            // Get array splice index
            let spliceIndex = Math.floor(Math.random() * password.length);
            password.splice(spliceIndex, 0, lastItem);
            n++
            }
        }
        return password.join("");
    },
    passwordReg:/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}|[\]\\:";'<>?,./])[A-Za-z\d~!@#$%^&*()_+`\-={}|[\]\\:";'<>?,./]{8,20}$/,
    currenyFormat(num){
        if (num) {
            num = typeof num == 'string' ? parseFloat(num) : num // 判断是否是字符串如果是字符串转成数字
            num = num.toFixed(2); // 保留两位
            // console.log(num)
            num = parseFloat(num); // 转成数字
            num = num.toLocaleString(); // 转成金额显示模式
            // 判断是否有小数
            // if (num.indexOf('.') === -1) {
            //   num =  num + '.00';
            // } else {
            //   // console.log(num.split('.')[1].length)
            //   num = num.split('.')[1].length < 2 ?  num + '0' : num;
            // }
          return num; // 返回的是字符串23,245.12保留2位小数
        } else {
          return 0;
        }
    },
    stripHtml(value) {
        return value ? value.replace(/<[^>]+>/g, '').trim() : '';
    },
    contentMaxLengthValidator(lang, max) {
        return {
            validator: (rule, value, callback) => {
                const text = value ? value.replace(/<[^>]+>/g, '').trim() : '';
                if (text.length > max) {
                    callback(new Error(`Inbox Content (${lang}) cannot exceed ${max} characters (current: ${text.length})`));
                } else {
                    callback();
                }
            },
            trigger: ['blur', 'change']
        };
    },
    pwdValidator(rule,value,callback){
        let pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}|[\]\\:";'<>?,./])[A-Za-z\d~!@#$%^&*()_+`\-={}|[\]\\:";'<>?,./]{8,20}$/;
        let reg = new RegExp("[\\u4E00-\\u9FFF]+","g");
        if(pattern.test(value)){
            if(reg.test(value)){
              callback(new Error("Password can not contain Chinese"));
            }else{
              callback()
            }
        }else{
            callback(new Error("Password length must be 8-20 and contain uppercase, lowercase, numeric and special characters"));
        }
    },
    telValidator(rule,value,callback){
        let pattern = /^(?:(?:\+|00))?((\d| ){0,})$/;
        if(pattern.test(value)){
            callback()
        }else{
            callback(new Error("Please enter the correct format"))
        }
    },
    orderValidator(rule,value,callback){
        let pattern = /^[1-9]\d*$/;
        if(pattern.test(value)){
            callback()
        }else{
            callback(new Error("Order must be integer"))
        }
    },
    propertySizeValidator(rule,value,callback){
        var reg = /(?:^[1-9]([0-9]+)?(?:\.[0-9]{1,})?$)|(?:^(?:0){1,}$)|(?:^[0-9]\.[0-9](?:[0-9]{1,})?$)/;
        if(value !== '') {
            if(reg.test(value)){
                callback()
            } else{
                callback(new Error("Property size must be number"))
            }
        }
        else {
            callback()
        }
    },
    amountsValidator(rule,value,callback){
        var reg = /(?:^[1-9]([0-9]+)?(?:\.[0-9]{1,})?$)|(?:^(?:0){1,}$)|(?:^[0-9]\.[0-9](?:[0-9]{1,})?$)/;
        if(reg.test(value)) {
            callback()
        } else{
                callback(new Error("Minimal Investment Amount must be number"))
        }
    },
    syndicationPriceValidator(rule,value,callback){
        var reg = /(?:^[1-9]([0-9]+)?(?:\.[0-9]{1,})?$)|(?:^(?:0){1,}$)|(?:^[0-9]\.[0-9](?:[0-9]{1,})?$)/;
        if(value){
            if(reg.test(value)){
                callback()
            }else{
                callback(new Error("Total syndication price must be number"))
            }
        }else{
            callback()
        }
    },
    deliveryDateValidator(rule,value,callback){
        if(new Date(value).getTime() < new Date().getTime()){
            callback(new Error("Delivery Date & Time cannot be earlier than the present time"))
        }else{
            callback()
        }
    },
    formatDisplayName(input, fallback = '') {
        const { lastName = '', firstName = '', fullName = '', name = '' } = input || {};
        const out = lastName.trim().length > 0 ? lastName + ', ' + firstName : fullName.length > 0 ? fullName : name;
        return (out || '').trim().length > 0 ? out : fallback;
    }
}



// WEBPACK FOOTER //
// ./src/script/common.js